function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { Link } from 'react-router-dom';
import { AppLink } from '@finect/tabular-core/AppLink';
import { getProductPath, getProductName, getProductTypeLabel } from '@finect/front-resources/Products';
import { dataLayer } from '@finect/front-gtm';
import { TableButton } from './partials';
export var ButtonLink = function ButtonLink(_ref) {
  var item = _ref.item,
    productType = _ref.productType,
    withSPA = _ref.withSPA,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? null : _ref$position,
    _ref$context = _ref.context,
    context = _ref$context === void 0 ? [] : _ref$context;
  var entity = item.product.entity;
  var path = getProductPath(_objectSpread({
    entity: entity
  }, {
    subtype: productType.id
  }), context);
  var productName = getProductName(entity, productType);
  var linkProps = withSPA ? {
    as: Link,
    to: path
  } : {
    as: AppLink,
    href: path
  };
  var handleMoreInfo = function handleMoreInfo(evt) {
    var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    !withSPA && evt.preventDefault();
    var layer = {
      id: 'ProductCard',
      type: 'productClick',
      params: {
        product: item.product,
        position: position,
        element: element
      },
      callback: withSPA ? undefined : function () {
        window.location = "".concat(path);
      }
    };
    dataLayer(layer);
  };
  return React.createElement(TableButton, _extends({
    onClick: function onClick(event) {
      handleMoreInfo(event, 'button');
    },
    width: "auto",
    variant: "small",
    title: "Ver ficha del ".concat(productType.singular, " ").concat(productName)
  }, linkProps), "Ver ", getProductTypeLabel(productType, 'shortSingular', 'lowercase'));
};